import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormikConfig } from 'formik'
import { changeDefaultManagerFormDefault } from './consts'
import { notification } from '@/shared/helpers/notificationMessages'
import { errorHandler } from '@/shared/lib/errorHandler'
import { useUserList } from '@/entities/User/api/user-api'
import { useChangeDefaultManagerApi } from '../api/use-change-default-manager-api'
import { useDefaultManager } from '@/entities/DefaultManager/api/default-manager-api'

export const useChangeDefaultManagerForm = (onCloseModal: () => void) => {
  const [initialValues, setInitialValues] = useState(() => changeDefaultManagerFormDefault)
  const { t } = useTranslation(['common'])

  const { data: defaultManager } = useDefaultManager()

  const { data: users, isLoading: isLoadingUsers } = useUserList({
    crm_responsible_id__isnull: false,
  })

  const { mutateAsync, isPending: isLoadingChangeDefaultManager } = useChangeDefaultManagerApi()

  useEffect(() => {
    if (defaultManager?.id) {
      setInitialValues({ id: String(defaultManager.id) })
    }
  }, [defaultManager])

  const submitForm: FormikConfig<any>['onSubmit'] = async values => {
    onCloseModal()
    notification.loading(
      t('common:notification_titles.please_wait'),
      t('common:notification_messages.create_template_in_progress'),
    )
    try {
      await mutateAsync(values)
      notification.success(
        t('common:notification_titles.success'),
        t('common:notification_messages.create_template_success'),
      )
    } catch (error) {
      errorHandler(error, t('common:notification_messages.create_template_error'))
    }
  }

  const userListOptions = (users?.data || []).map(user => ({
    label: user.fullname as string,
    value: String(user.id),
  }))

  return {
    userListOptions,
    isLoadingUsers,
    initialValues,
    isLoadingChangeDefaultManager,
    submitForm,
  }
}
